import React from 'react';
import {useNavigate} from "react-router-dom";

function SubscriptionOption({title, status, start ,end}) {
    const navigate = useNavigate();
    function calculateProgressPercentage() {
        const startDate = new Date(start);
        const endDate = new Date(end);
        const currentDate = new Date();
        if (currentDate > endDate) {
            return 100;
        }
        if (currentDate < startDate) {
            return 0;
        }
        const totalTime = endDate.getTime() - startDate.getTime();
        const elapsedTime = currentDate.getTime() - startDate.getTime();
        const progressPercentage = (elapsedTime / totalTime) * 100;
        return Math.round(progressPercentage);
    }
    return (
        <div className="card">
            <div className="card-body h-px-150">
                <h5 className="card-title mb-2">{title}</h5>
                <span className="badge bg-label-success mb-3">{status}</span>
                <div className="d-flex align-items-center">
                    <div className="progress w-50 me-2" style={{height: '8px'}}>
                        <div className="progress-bar bg-info" style={{width: calculateProgressPercentage()+'%'}} role="progressbar"
                             aria-valuenow="78"
                             aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <span>{calculateProgressPercentage()}%</span>
                </div>
                <a type={"button"} className="text-netikash d-block" onClick={()=>navigate("/")}>Changer plan</a>
            </div>
        </div>
    );
}

export default SubscriptionOption;
